export * from "./ATypeFacilityFAQ";
export * from "./BTypeFacilityFAQ";
export * from "./CTypeFacilityFAQ";
export * from "./DTypeFacilityFAQ";
